import { HeaderContainer } from './styles';

export default HeaderContainer;
